import { ECS } from '../state';
import { randomInRange } from '~/helpers/MathUtils';
import { urls } from '@/config/assets';
import { beerConfig } from '@/config/games/beer';
import { randomIntRange, randomSign } from '~/helpers/MathUtils';
import sample from 'lodash/sample';

export const Characters = () => {
  // useEffect(() => {
  //   clearCharacters();
  //   addCharacters(0);
  // }, []);

  return (
    <>
      <ECS.Entities
        in={characters}
        children={Character}
      />
    </>
  );
};

export const Character = (entity) => {
  const [
    //
    t_bird,
    t_dog1,
    t_dog2,
    t_person,
  ] = useAsset([
    //
    urls.t_bird,
    urls.t_dog1,
    urls.t_dog2,
    urls.t_person,
  ]);

  const textures = {
    bird: t_bird,
    dog1: t_dog1,
    dog2: t_dog2,
    person: t_person,
  };

  const texture = textures[entity.type];

  const [isPast, setIsPast] = useState(false);

  useFrame(() => {
    const player = players.entities[0];
    if (!isPast && entity.position.x + 0.1 < player.position.x) {
      setIsPast(true);
      // console.log('is past');
    }
  });

  return (
    <ECS.Entity entity={entity}>
      <ECS.Component name="three">
        <group>
          <group position={[0, entity.size[1] * 0.5, 0]}>
            <mesh scale={[isPast ? 1 : -1, 1, 1]}>
              <planeGeometry args={[entity.size[0], entity.size[1]]} />
              <GBufferMaterial transparent>
                <MaterialModuleMap map={texture} />
                <MaterialModuleAlphaTest />
              </GBufferMaterial>
            </mesh>
          </group>
        </group>
      </ECS.Component>
    </ECS.Entity>
  );
};

export const clearCharacters = () => {
  ECS.world.remove(characters);
};

// export const addCharacters = (areaIdx) => {
//   const area = beerConfig.areas[areaIdx];

//   let lastX = 0;

//   for (let i = 0; i < area.numCharacters; i++) {
//     lastX += randomInRange(CLOUD_GAP_MIN, CLOUD_GAP_MAX);

//     // const y = randomInRange(1.75, 9);
//     const y = 0;
//     const z = randomInRange(-14, -3);
//     const type = sample(area.characters);

//     const scale = area.characterScale;
//     const flip = randomSign();

//     addCharacter(lastX, y, z, scale, scale, type, flip);
//   }
// };

export const addCharacter = (
  x = 0,
  y = 0,
  z = -5,
  width = 2,
  height = 1,
  type = 0,
  flip = 1
) => {
  const opts = {
    isCharacter: true,
    position: { x, y, z },
    size: [width, height, 1],
    flip,
    type,
  };

  ECS.world.add(opts);
};
